import MaterialIcon from '@material/react-material-icon';
import './MaterialIcon.scss';

export default MaterialIcon;
